export default __webpack_public_path__ + "static/expert_on_the_way_mail-effd32cfa5421188558773d83900236e.svg";